import './style.css';
import { Map, View } from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';
import Text from 'ol/style/Text';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import ImageWMS from 'ol/source/ImageWMS';
import { Image as ImageLayer } from 'ol/layer'
import MVT from 'ol/format/MVT';
import { createXYZ } from 'ol/tilegrid';
import { transformExtent } from 'ol/proj';
import Overlay from 'ol/Overlay';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { defaults as defaultControls, Control } from "ol/control";

var mapExtent = transformExtent([-180.000000, -90.00000, 180.000000, 90.000000], 'EPSG:4326', 'EPSG:3857');
var mapMinZoom = 0;
var mapMaxZoom = 8;
var selection = {};

const region = new Style({
  stroke: new Stroke({
    color: 'red',
    width: 1,
  }),
  fill: new Fill({
    color: 'rgba(0,255,0,0.3)',
  }),
});

const labelStyle = new Style({
  stroke: new Stroke({
    color: 'red',
    width: 1,
  }),
  text: new Text({
    font: '16px Calibri,sans-serif',
    overflow: true,
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 3,
    }),
  }),
});

const selectedRegion = new Style({
  stroke: new Stroke({
    color: 'rgba(200,20,20,0.8)',
    width: 2,
  }),
  fill: new Fill({
    color: 'rgba(200,20,20,0.4)',
  })
});

class RegionControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const element = document.createElement('div');
    element.innerHTML = 'Region: ';
    element.id = "regionname";
    super({
      element: element,
      target: options.target,
    });
  }
}
class HelpControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    const img = document.createElement('img');
    img.src = 'images/help.png';
    img.className = 'helpimage ol-unselectable ol-control';
    img.id = 'helpimage';

    super({
      element: img,
      target: options.target,
    });

    img.addEventListener('click', this.handleHelp.bind(this), false);
  }

  handleHelp() {
    if (document.getElementById("help").style.display === "none") {
      document.getElementById("help").style.display = "block";
      document.getElementById("helpimage").style.border = "solid 3px red";
    } else {
      document.getElementById("help").style.display = "none";
      document.getElementById("helpimage").style.border = "none";
    }
  }
}

class TocControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};

    var tocDiv = document.createElement("div");
    var checkboxItem = document.createElement("input");
    checkboxItem.type = "checkbox";
    checkboxItem.name = "toc";
    checkboxItem.id = "toc";
    checkboxItem.value = "noaa";
    checkboxItem.defaultChecked = true;
    checkboxItem.checked = true;
    checkboxItem.style.float = 'left';
    tocDiv.appendChild(checkboxItem);
    const label = document.createElement("div");
    label.id = "labeldiv";
    label.innerHTML = ' NOAA Bathymetry data - visit the <a target="_blank" href="https://www.ncei.noaa.gov/maps/bathymetry/">NOAA viewer</a> for data & info<br>';
    tocDiv.appendChild(label);

    tocDiv.style.cssText =
      "margin-left: 4px; border: 1px solid black; position:absolute; bottom:10px; left:10px; width: 445px; height:28px; background-color:white;";
    tocDiv.className = "tocDiv";
    tocDiv.id = "tocDiv";

    super({
      element: tocDiv,
      target: options.target,
    });

    tocDiv.addEventListener(
      "click",
      this.handleTocDivChange.bind(this),
      false
    );

  }
  handleTocDivChange() {

    let toclayer = document.getElementById('toc');
    if (toclayer.checked) {
      noaa.setVisible(true);
    } else {
      noaa.setVisible(false);
    }
    /*
    let toclayer = document.getElementsByName('radioGrp');
    if (toclayer[0].checked) {
      bathyLayer.setVisible(true);
      bathySelectionLayer.setVisible(true);
      midresLayer.setVisible(false);
      midresSelectionLayer.setVisible(false);
    } else {
      bathyLayer.setVisible(false);
      bathySelectionLayer.setVisible(false);
      midresLayer.setVisible(true);
      midresSelectionLayer.setVisible(true);
    }
    */
  }
}

// wms marine labels

/*
var labels = new ImageLayer({
  visible: true,
  source: new ImageWMS({
    url: 'https://www.opendem.info/geoserver/opendem/wms',
    params: {
      'LAYERS': 'opendem:marine_labelsxxxx'
    }
  })
});
*/

var fallback = false;

var wmsLabelsSource = new ImageWMS({
  url: "https://www.opendem.info/geoserver/opendem/wms",
  params: { LAYERS: "opendem:marine_labels" },
  serverType: "geoserver",
  imageLoadFunction: function (image, src) {
    var xhttp = new XMLHttpRequest();
    xhttp.responseType = "arraybuffer";
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var arrayBufferView = new Uint8Array(this.response);
        var blob = new Blob([arrayBufferView], {
          type: 'image/png'
        });
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(blob);
        image.getImage().src = imageUrl;
      } else {

        // fallback with point geojson
        // something wrong but service available
        // 404 not found
        if (this.status == 404) {
          if (fallback == false) {
            var namesJson = new VectorLayer({
              source: new VectorSource({
                format: new GeoJSON(),
                url: 'labels_points.geojson'
              }),
              style: function (feature) {

                let zoom = map.getView().getZoom();
                zoom = zoom - 2;
                if (zoom < 0) {
                  zoom = 0;
                }
                const labelscale = feature.get('scalerank');

                if (zoom >= labelscale) {
                  const label = feature.get('label');
                  labelStyle.getText().setText(label);
                  return labelStyle;
                }
              }

            });

            map.addLayer(namesJson);

            map.getLayers().forEach(function (layer) {

              try {
                if (layer.getClassName() == 'labelLayer') {
                  map.removeLayer(layer);
                  fallback = true;
                }
              } catch (e) { }
            });

          }
        }
      }
    };
    xhttp.onerror = function () {
      // no service available
      // fallback with point geojson
      if (fallback == false) {
        var namesJson = new VectorLayer({
          source: new VectorSource({
            format: new GeoJSON(),
            url: 'labels_points.geojson'
          }),
          style: function (feature) {

            let zoom = map.getView().getZoom();
            zoom = zoom - 2;
            if (zoom < 0) {
              zoom = 0;
            }
            const labelscale = feature.get('scalerank');

            if (zoom >= labelscale) {
              const label = feature.get('label');
              labelStyle.getText().setText(label);
              return labelStyle;
            }
          }

        });

        map.addLayer(namesJson);

        map.getLayers().forEach(function (layer) {

          try {
            if (layer.getClassName() == 'labelLayer') {
              map.removeLayer(layer);
              fallback = true;
            }
          } catch (e) { }
        });

      }
    };
    xhttp.open("GET", src, true);
    xhttp.setRequestHeader("Content-type", "text/xml");
    xhttp.send();
  },
  crossOrigin: "anonymous",
});
var labels = new ImageLayer({
  source: wmsLabelsSource,
  className: 'labelLayer'
});

// NOAA GeoJSON Vector layer
var noaa = new VectorLayer({
  className: 'noaa',
  visible: true,
  source: new VectorSource({
    format: new GeoJSON(),
    url: 'noaa_sub.geojson'
  }),
  style: region
});

var bathyLayer = new VectorTileLayer({
  className: 'bathyLayer',
  declutter: true,
  source: new VectorTileSource({
    attributions: ', Made with <a target="_blank" href="http://www.naturalearthdata.com/">Natural Earth</a>.',
    format: new MVT(),
    tileGrid: createXYZ({
      minZoom: mapMinZoom,
      maxZoom: mapMaxZoom,
      tileSize: 512,
    }),
    tilePixelRatio: 8,
    url: "v_bathymetry/{z}/{x}/{y}.pbf",
  }),
  extent: mapExtent,
  style: region
});

var view = new View({
  center: [0, 0],
  zoom: 2
});

let map = new Map({
  target: 'map',
  controls: defaultControls().extend([
    new TocControl(),
    new RegionControl(),
    new HelpControl()
  ]),
  layers: [
    new TileLayer({
      source: new OSM()
    }),
    bathyLayer,
    noaa,
    labels
  ],
  view: view
});

// Selection
const bathySelectionLayer = new VectorTileLayer({
  map: map,
  className: 'bathySelectionLayer',
  renderMode: 'vector',
  source: bathyLayer.getSource(),
  style: function (feature) {
    if (feature.getId() in selection) {
      return selectedRegion;
    }
  }
});


// Popup
var container = document.getElementById('popup');
var content = document.getElementById('popup-content');
var closer = document.getElementById("popup-closer");

var overlay = new Overlay({
  element: container,
  autoPan: true,
  autoPanAnimation: {
    duration: 250
  },
});

closer.onclick = function () {
  overlay.setPosition(undefined);
  closer.blur();
  return false;
};
map.addOverlay(overlay);

map.on('singleclick', function (e) {
  var htmlDivs = '';
  var htmlTabs = '';
  var htmlRegion1 = '';
  var html = '';
  var counter = 1;
  map.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
    var props = feature.getProperties();

    if (layer) {

      // NOAA
      if (layer.getClassName() === 'noaa') {

        var downloadURL = 'not available';
        if (props.DOWNLOAD_U != undefined) {
          downloadURL = '<a target="_blank" href="' + props.DOWNLOAD_U + '">Link</a>';
        }
        var metadataURL = 'not available';
        if (props.METADATA_U != undefined) {
          metadataURL = '<a target="_blank" href="' + props.METADATA_U + '">Link</a>';
        }

        if (counter === 1) {

          htmlRegion1 = props.NAME;
          htmlDivs += `<div id="tab1" class="inspect-layer">
                  <h3>Region: ${props.NAME}</h3>
                  <p>Data from NOAA  <a target="_blank" href="https://www.ncei.noaa.gov/maps/bathymetry/">Bathymetric Data Viewer</a> 11/2025 </p>
                  <ul style="list-style-type:none;">  
                  <li>Metadata: ${metadataURL}</li>
                  <li>Download: ${downloadURL}</li>
                  <li>Resolution: ${props.CELL_SIZE}</li>
                  </ul>
                  </div > `;
        }
        if (counter === 2) {

          // Tabs
          htmlTabs += `<li><a href="javascript:void(0)" class="tablinks active"
                  onclick="switchTabs(event, \'tab1\')" id="defaultOpen">${htmlRegion1}</a></li>`;
          htmlTabs += `<li><a href="javascript:void(0)" class="tablinks"
          onclick="switchTabs(event, \'tab2\')">${props.NAME}</a></li>`;


          // DIV
          htmlDivs += `<div id="tab${counter}" class="inspect-layer-deactive">
                  <h3>Region: ${props.NAME}</h3>
                  <p>Data from NOAA  <a target="_blank" href="https://www.ncei.noaa.gov/maps/bathymetry/">Bathymetric Data Viewer</a> 11/2025 </p>
                  <ul style="list-style-type:none;">    
                  <li>Metadata: ${metadataURL}</li>
                  <li>Data downkload: ${downloadURL}</li>  
                  <li>Resolution: ${props.CELL_SIZE}</li>
                  </ul>
                  </div>`;
        }

        if (counter > 2) {

          // Tabs
          htmlTabs += `<li><a href="javascript:void(0)" class="tablinks"
          onclick="switchTabs(event, \'tab${counter}\')">${props.NAME}</a></li>`;


          // DIV
          htmlDivs += `<div id="tab${counter}" class="inspect-layer-deactive">
                  <h3>Region: ${props.NAME}</h3>
                  <p>Data from NOAA  <a target="_blank" href="https://www.ncei.noaa.gov/maps/bathymetry/">Bathymetric Data Viewer</a> 11/2025 </p>
                  <ul style="list-style-type:none;">    
                  <li>Metadata: ${metadataURL}</li>
                  <li>Data downkload: ${downloadURL}</li>  
                  <li>Resolution: ${props.CELL_SIZE}</li>
                  </ul>
                  </div>`;
        }

        counter++;

      } else {

        // openDEM
        var licenseURL = '';
        if (props.l_link != undefined) {
          licenseURL = '<a target="_blank" href="' + props.l_link + '">' + props.license + '</a>';
        }
        var dtmURL = '';
        if (props.data_url != undefined) {
          dtmURL = '<a target="_blank" href="' + props.data_url + '">Link</a>';
        }

        var comment = '';
        if (props.comment != undefined) {
          comment = props.comment;
        }

        if (counter === 1) {

          htmlRegion1 = props.region;
          htmlDivs += `<div id="tab1" class="inspect-layer">
          <h3>Region: ${props.region}</h3>
          <ul style="list-style-type:none;">
          <li>Distributor: <a target="_blank" href="${props.d_link}">${props.distributo}</a></li>
          <li>License: ${licenseURL}</li>
          <li>Method/Metadata:: <a target="_blank" href="${props.method}">Link</a></li>
          <li>Resolution: ${props.resolution}</li>
          <li>Data: ${dtmURL}</li>
          <li>Comment: ${comment}</li>
          </ul>
          </div> `;
        }
        if (counter === 2) {

          // Tabs
          htmlTabs += `<li><a href="javascript:void(0)" class="tablinks active"
                  onclick="switchTabs(event, \'tab1\')" id="defaultOpen">${htmlRegion1}</a></li>`;
          htmlTabs += `<li><a href="javascript:void(0)" class="tablinks"
          onclick="switchTabs(event, \'tab2\')">${props.region}</a></li>`;


          // DIV
          htmlDivs += `<div id="tab${counter}" class="inspect-layer-deactive">
          <h3>Region: ${props.region}</h3>
          <ul style="list-style-type:none;">
          <li>Distributor: <a target="_blank" href="${props.d_link}">${props.distributo}</a></li>
          <li>License: ${licenseURL}</li>
          <li>Method/Metadata:: <a target="_blank" href="${props.method}">Link</a></li>
          <li>Resolution: ${props.resolution}</li>
          <li>Data: ${dtmURL}</li>
          <li>Comment: ${comment}</li>
          </ul>
          </div>`;
        }

        if (counter > 2) {

          // Tabs
          htmlTabs += `<li><a href="javascript:void(0)" class="tablinks"
          onclick="switchTabs(event, \'tab${counter}\')">${props.region}</a></li>`;


          // DIV
          htmlDivs += `<div id="tab${counter}" class="inspect-layer-deactive">
                  <h3>Region: ${props.region}</h3>
                  <ul style="list-style-type:none;">
                  <li>Distributor: <a target="_blank" href="${props.d_link}">${props.distributo}</a></li>
                  <li>License: ${licenseURL}</li>
                  <li>Method/Metadata:: <a target="_blank" href="${props.method}">Link</a></li>
                  <li>Resolution: ${props.resolution}</li>
                  <li>Data: ${dtmURL}</li>
                  <li>Comment: ${comment}</li>
                  </ul>
                  </div>`;
        }
        counter++;
      }


    } // else ende noaa

  });

  // create complete popup

  if (counter > 1) {
    html += '<ul class="tab">' + htmlTabs + '</ul>' + htmlDivs;
  } else {
    html += htmlDivs;
  }
  window.bathymetriecounter = counter - 1;


  if (html.length > 0) {
    content.innerHTML = html;
    if (e.coordinate[1] > 0) {
      document.getElementById('popup').className = 'ol-popup-bottom';
    } else {

      document.getElementById('popup').className = 'ol-popup';
    }
    overlay.setPosition(e.coordinate);

  } else {
    overlay.setPosition(undefined);
  }
});

const selectElement = document.getElementById('type');

// MouseOver Selection
map.on('pointermove', function (event) {
  if (bathySelectionLayer.getVisible()) {
    bathyLayer.getFeatures(event.pixel).then(function (features) {
      if (!features.length || !bathySelectionLayer.getVisible()) {
        selection = {};
        bathySelectionLayer.changed();
        document.getElementById('regionname').innerHTML = 'Region:';
        return;
      }
      if (!features) {
        return;
      }


      //console.log(features.length);
      // only the above feature is detected here
      document.getElementById('regionname').innerHTML = 'Region: ' + features[0].properties_.region;

      // add selected feature to lookup
      const feature = features[0];
      const fid = feature.getId();
      selection[fid] = feature;
      bathySelectionLayer.changed();
    });
  } else {
    midresLayer.getFeatures(event.pixel).then(function (features) {
      if (!features.length || !midresSelectionLayer.getVisible()) {
        selection = {};
        midresSelectionLayer.changed();
        document.getElementById('regionname').innerHTML = 'Region:';
        return;
      }
      const feature = features[0];
      if (!feature) {
        return;
      }
      const fid = feature.getId();
      document.getElementById('regionname').innerHTML = 'Region: ' + features[0].properties_.region;
      // add selected feature to lookup
      selection[fid] = feature;
      midresSelectionLayer.changed();
    });
  }
});
